import React from "react";
import { toCurrency } from "../../diamondCasinoAllGames/race17/race17Cards";

// Reference computed markets (Vue raceto17 page): each is `sub` filtered by subtype, ordered by sr
const MARKETS = [
  { subtype: "race17", fallback: "Race to 17" },
  { subtype: "bigcard", fallback: "Big Card (7,8,9)", visibleOnly: true },
  { subtype: "zerocard", fallback: "Zero Card", visibleOnly: true },
  { subtype: "anyzero", fallback: "Any Zero" },
];

function getExposure(exposures, nat) {
  if (!nat) return 0;
  return exposures[nat] ?? exposures[nat.toLowerCase()] ?? exposures[nat.trim()] ?? 0;
}

function pickMarket(data, { subtype, visibleOnly }, idx) {
  const bySubtype = data
    .filter((s) => s?.subtype === subtype && (!visibleOnly || Number(s?.visible) === 1))
    .sort((a, b) => (Number(a?.sr) || 0) - (Number(b?.sr) || 0));
  // Our backend may not send `subtype` — fall back to the n-th market of the feed
  return bySubtype[0] ?? (data.some((s) => s?.subtype) ? undefined : data[idx]);
}

/**
 * BetTableRace17 — Race to 17 bet table in the reference markup (allpanel9 admin, tablet/desktop template):
 *   .row.row5.d-none-small > .col-3 × 4 >
 *     .casino-box-row > .casino-nation-name > b(nat)
 *                     + .casino-bl-box > .back.casino-bl-box-item[.suspended] + .lay.casino-bl-box-item[.suspended]
 *                     + .casino-nation-name.book-red|book-green (v-casinofancybook: amount, green when > 0)
 * Styled by the ported reference rules (.raceto17 … in index.css).
 */
export default function BetTableRace17({ data = [], onBetClick, exposures = {} }) {
  return (
    <div className="row row5 d-none-small">
      {MARKETS.map((m, idx) => {
        const item = pickMarket(data, m, idx);
        const nat = item?.nat || m.fallback;
        const suspended = item?.gstatus !== "OPEN";
        const book = Number(getExposure(exposures, nat)) || 0;
        const click = (value, type) => {
          if (!suspended && onBetClick) onBetClick(value, nat, type, item);
        };

        return (
          <React.Fragment key={m.subtype}>
            {idx > 0 && " "}
            <div className="col-3">
              <div className="casino-box-row">
                <div className="casino-nation-name">
                  <b>{nat}</b>
                </div>{" "}
                <div className="casino-bl-box">
                  <div
                    className={`back casino-bl-box-item${suspended ? " suspended" : ""}`}
                    onClick={() => click(item?.b, "back")}
                  >
                    <span className="casino-box-odd">{item?.b}</span>
                  </div>{" "}
                  <div
                    className={`lay casino-bl-box-item${suspended ? " suspended" : ""}`}
                    onClick={() => click(item?.l, "lay")}
                  >
                    <span className="casino-box-odd">{item?.l}</span>
                  </div>
                </div>{" "}
                <div className={`casino-nation-name ${book > 0 ? "book-green" : "book-red"}`}>
                  {book ? toCurrency(book) : 0}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
